import cx from 'classnames';
import React, { PropsWithChildren, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { CancelStatusDetails } from 'enums';
import { useOrderContext, useTrackFlowEvent } from 'hooks';
import { TranslationNamespace } from 'i18n';

import { SQ_ICON_CONFIG } from './constants';

type Props = PropsWithChildren;

export const SqPaymentStatusLayout: React.FC<Props> = ({ children }) => {
  const { order, paymentStatusView } = useOrderContext();

  useTrackFlowEvent();

  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: `components.sq_payment_view.${paymentStatusView}`,
  });

  const { iconPath, iconBg } = useMemo(
    () => SQ_ICON_CONFIG[paymentStatusView],
    [paymentStatusView],
  );

  const areAlternativesExhausted = useMemo(
    () =>
      order?.statusDetails ===
      CancelStatusDetails.CancelledCustomerAlternativesExhausted,
    [order?.statusDetails],
  );

  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-flex-1 tw-w-full">
      <div
        className={cx(
          'tw-w-20 tw-h-20 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mb-6',
          iconBg,
        )}
      >
        <img className="tw-w-9" src={iconPath} alt="" />
      </div>

      <div className="tw-text-3xl tw-font-medium tw-text-primary tw-text-center tw-mb-2">
        {t('title')}
      </div>

      {!areAlternativesExhausted && (
        <div className="tw-text-md tw-text-secondary tw-text-center tw-mb-6">
          {t('message')}
        </div>
      )}

      {children}
    </div>
  );
};
